import { getEnvironmentLabel, apiDomain, isLocalhost } from "@maersk-global/shared-js";

const maerskApiDomain = () => {
  if (isLocalhost()) {
    return "http://localhost:3000/api";
  }
  return "https://" + apiDomain(new URL(window.location.href));
};

const ENV_LABEL = getEnvironmentLabel();

const PENSIEVE_CONFIG = {
  localhost: {
    applicationName: "ShipmentOverview-Demo",
    apiKey: "SlbaZbzOaQzsoF+0bwqt6OiT+Ct6Wx7dCq9Ta27SMiNG1hiaZNnG0xQUGLhktg==",
    env: "stage"
  },
  preprod: {
    applicationName: "ShipmentOverview-Demo",
    apiKey: "SlbaZbzOaQzsoF+0bwqt6OiT+Ct6Wx7dCq9Ta27SMiNG1hiaZNnG0xQUGLhktg==",
    env: "stage"
  },
  prod: {
    applicationName: "ShipmentOverview-Prod",
    apiKey: "SlbaZbzOaQvopg3ibFmnucxti3c8Z/SsF817YZBhhF6AySvArgEYL8ybdb5m0w==",
    env: "prod"
  }
};

/**
 * @constant
 * @description Global constants containing business information.
 * @type {object}
 * @namespace
 */
export default {
  APP_BASE: "shipments",

  BRANDS: [
    {
      brandName: "maersk",
      brandCode: "maeu",
      marketingBrandCode: "maeu",
      commercialName: "Maersk",
      domain: "maersk.com"
    },
    {
      brandName: "maerskline",
      brandCode: "maeu",
      marketingBrandCode: "maeu",
      commercialName: "Maersk",
      domain: "maerskline.com"
    },
    {
      brandName: "safmarine",
      brandCode: "safm",
      marketingBrandCode: "safm",
      commercialName: "Safmarine",
      domain: "safmarine.com"
    },
    {
      brandName: "sealand",
      brandCode: "seau",
      marketingBrandCode: "seau",
      commercialName: "Sealand - A Maersk Company",
      domain: "sealand.com"
    },
    {
      brandName: "seagoline",
      brandCode: "sejj",
      marketingBrandCode: "seau",
      commercialName: "Sealand - A Maersk Company",
      domain: "seagoline.com"
    },
    {
      brandName: "mcc",
      brandCode: "mcpu",
      marketingBrandCode: "seau",
      commercialName: "Sealand - A Maersk Company",
      domain: "mcc.com.sg"
    },
    {
      brandName: "maersk line limited",
      brandCode: "maei",
      marketingBrandCode: "maei",
      commercialName: "Maersk Line Limited",
      domain: "maersklinelimited.com"
    }
  ],

  /**
   * Added strings required for cargo data rules here as 't' function cannot be called in store.
   * Please suggest if anyone has a better idea of doing it.
   */

  CARGO_VARIOUS_CONTAINERS: "cargo.variousContainers",

  CARGO_VARIOUS_COMMODITIES: "cargo.variousCommodities",

  DEFAULT_LANGUAGE: "en",

  CONTAINER_MOVE_TYPES: {
    APPTCONF: "APPTCONF",
    ARRIVECU: "ARRIVECU",
    DEPARTCU: "DEPARTCU",
    DISCHARGE: "DISCHARG",
    DISPOSED: "DISPOSED",
    GATE_IN: "GATE-IN",
    GATE_IN_EMPTY: "GATE-IN-EMPTY",
    GATE_OUT: "GATE-OUT",
    GATE_OUT_EMPTY: "GATE-OUT-EMPTY",
    INTERCHG: "INTERCHG",
    LEASE: "LEASE",
    LOAD: "LOAD",
    NOTIFYMT: "NOTIFYMT",
    OFF_RAIL: "OFF-RAIL",
    ON_RAIL: "ON-RAIL",
    PURCHASE: "PURCHASE",
    RAILSPOT: "RAILSPOT",
    REDELIVR: "REDELIVR",
    SHIFT_C: "SHIFT-C",
    SHIFT_P: "SHIFT-P",
    STRIPPING: "STRIPPIN",
    STRIPPING_EMPTY: "STRIPPIN-EMPTY",
    STUFFING: "STUFFING"
  },

  FAKE_CONTAINER_MOVE_TYPES: {
    ON_TRUCK: "ON-TRUCK",
    OFF_TRUCK: "OFF-TRUCK",
    ON_BARGE: "ON-BARGE",
    OFF_BARGE: "OFF-BARGE"
  },

  MODE_CODES: {
    VSM: "VSM",
    BAR: "BAR",
    FEO: "FEO",
    COM: "COM",
    TRK: "TRK",
    BCO: "BCO",
    RSD: "RSD",
    RR: "RR",
    RCO: "RCO",
    REI: "REI",
    MVS: "MVS",
    FEF: "FEF",
    SSH: "SSH",
    VSF: "VSF",
    DST: "DST",
    VSL: "VSL"
  },

  MODE_DESCRIPTIONS: {
    VSA_MOTHER_VSL: "VSA MOTHER VSL",
    BARGE: "BARGE",
    FEEDER_OWN: "FEEDER OWN",
    COMBINED_TRANSPORT: "COMBINED TRANSPORT",
    TRUCK: "TRUCK",
    BARGE_COMBINED_TRANSPORT: "BARGE - COMBINED TRANSPORT",
    RAIL_STOREDOOR: "RAIL STOREDOOR",
    RAIL: "RAIL",
    RAIL_ROAD_COMBINED: "RAIL/ROAD - COMBINED",
    MOTHER_VESSEL: "MOTHER_VESSEL",
    FEEDER_FOREIGN: "FEEDER FOREIGN",
    EQUALIZATION: "EQUALIZATION",
    VSA_FEEDER: "VSA FEEDER",
    DOUBLESTACK: "DOUBLESTACK",
    USA_FEEDER: "USA FEEDER"
  },

  TIMELINE_MODES: {
    PCY: "PORT_CY",
    CY: "CY",
    SD: "SD",
    OT: "OT"
  },

  MOVE_MODES_MAPPING: {
    "ON-RAIL": ["RR"],
    "OFF-RAIL": ["RR"],
    "GATE-IN": ["BAR", "TRK", "COM", "BCO", "RCO"],
    "GATE-OUT": ["BAR", "TRK", "COMB", "BCO", "RCO"]
  },

  /*
  // CONTAINER_NO_OR_TPDOC_REGEX: Maersk OWASP rules
  // OWASP top 10 rules (from http://erlend.oftedal.no/blog/?blogid=125 )
  // Need to apply OWASP validation to the TP Doc in search bar before redirecting to the Shipmemt Details as per the story AOSM-234
  // (https://jira.maerskdev.net/browse/AOSM-234)
  */

  TPDOC_NUMBER_REGEX: /^\b[A-Za-z0-9]{9}\b$/,
  CONTAINER_ID_REGEX: /^\b[A-Za-z]{4}[0-9]{7}\b$/,

  ICON_MAPPING: new Map([
    ["MVS", "ship"],
    ["VSA", "ship"],
    ["VSM", "ship"],
    ["FEO", "ship"],
    ["FEF", "ship"],
    ["LOAD", "return"],
    ["TRK", "truck"],
    ["BAR", "tug"],
    ["DISCHARG", "release"]
  ]),
  GACategory: "UX_ShipmentMngt",
  TASK_CODES: {
    IMPORT_CUSTOMS_MANIFEST: "0000000000068",
    CUSTOMS_RELEASE: "0000000000101",
    BILL_OF_LADING_SURRENDERED: "0000000000069",
    ARRANGE_CARGO_RELEASE: "0000000000074",
    APPROVE_FREIGHT_RELEASE_DOCUMENTATION: "0000000000100",
    APPROVE_FREIGHT_RELEASE_IMPORT: "0000000000103",
    APPLY_AND_VERIFY_PAYMENT_TERMS: "0000000000124",
    RECEIVE_TRANSPORT_DOCUMENT_INSTRUCTIONS: "0000000000058",
    RESOLVE_MISSING_VGM_DATA: "0000000000129",
    CONFIRM_SHIPMENT: "0000000000011",
    ISSUE_ORIGINAL_TRANSPORT_DOCUMENT: "0000000000083",
    DANGEROUS_GOODS_DECLARATION_RECEIVED: "0000000000064",
    MARK_ORIGINAL_TRANSPORT_DOCUMENT_AS_RECEIVED: "0000000000069",
    ISSUE_VERIFY_COPY_OF_TRANSPORT_DOCUMENT: "0000000000081",
    ISSUE_AMENDED_VERIFY_COPY_OF_TRANSPORT_DOCUMENT: "0000000000095",
    APPROVE_DANGEROUS_CARGO: "0000000000026",
    APPROVE_OOG_CARGO: "0000000000027"
  },

  GA_DOCUMENT_MAP: {
    originalBoL: "Original BL",
    wayBill: "Waybill",
    bookingConfirmation: "Booking Confirmation",
    equipmentReleaseOrder: "Equipment Release Order",
    verifyCopy: "Verify Copy",
    ebl: "Electronic Bill of Lading",
    billOfLading: "Bill of Lading",
    waybill: "Waybill",
    certifiedTrueCopy: "Certified True Copy",
    arrivalNotice: "Arrival Notice",
    deliveryOrder: "Delivery Order"
  },

  TASK_STATUSES: {
    PENDING: "1",
    OPEN: "2",
    IN_PROGRESS: "3",
    CLOSED: "4",
    CANCELLED: "5"
  },

  SSDO_URLS: {
    ROLE_ONE: "",
    ROLE_TWO: ""
  },

  PENDING_TASKS_MAPPING_COLLECTION: new Map([
    [
      "0000000000069, import", //TASK_CODES.BILL_OF_LADING_SURRENDERED,
      {
        title: "pending.tasks.title.for.surrender.original.bl",
        details: "pending.tasks.details.for.surrender.original.bl",
        link: "pending.tasks.link.for.surrender.original.bl",
        permission: "surrender-b-l"
      }
    ],
    [
      "0000000000074, import", //TASK_CODES.ARRANGE_CARGO_RELEASE,
      {
        title: "pending.tasks.title.for.request.delivery.order",
        details: "pending.tasks.details.for.request.delivery.order",
        link: "pending.tasks.link.for.request.delivery.order",
        permission: "delivery-order-status"
      }
    ],
    [
      "0000000000058, export", //TASK_CODES.RECEIVE_TRANSPORT_DOCUMENT_INSTRUCTIONS
      [
        //Submit Shipping Instructions
        {
          title: "export.pending.tasks.title.for.submit.shipping.instructions",
          link: "export.pending.tasks.link.for.submit.shipping.instructions",
          statusCode: "2", //OPEN
          additionalTaskConditions: [{ taskCode: "0000000000011", statusCode: "4" }],
          mainAdditionalTaskConditionsOperator: "AND",
          permission: "submit-si"
        }
        //Amend Shipping Instructions - remvoing as per AOSM-4801
        // {
        //   title: "export.pending.tasks.title.for.amend.shipping.instructions",
        //   link: "export.pending.tasks.link.for.amend.shipping.instructions",
        //   statusCode: "4", //CLOSED,
        //   additionalTaskConditions: [
        //     { taskCode: "0000000000081", statusCode: "4" }, //TASK_CODES.ISSUE_VERIFY_COPY_OF_TRANSPORT_DOCUMENT
        //     { taskCode: "0000000000095", statusCode: "4" } //TASK_CODES.ISSUE_AMENDED_VERIFY_COPY_OF_TRANSPORT_DOCUMENT
        //   ],
        //   mainAdditionalTaskConditionsOperator: "AND",
        //   additionalTaskConditionsOperator: "OR", //use it between additionalTaskConditions i.e. ATC1 OR ATC2 OR ATC3
        //   permission: "submit-si"
        // }
      ]
    ],
    [
      "0000000000129, export", // TASK_CODES.RESOLVE_MISSING_VGM_DATA
      {
        title: "export.pending.tasks.title.for.submit.vgm",
        link: "export.pending.tasks.link.for.submit.vgm",
        useRouterNavigation: true,
        routeName: "vgm",
        permission: "submit-vgm",
        additionalTaskConditions: [
          { taskCode: "0000000000129", statusCode: "2" },
          { taskCode: "0000000000129", statusCode: "3" }
        ],
        mainAdditionalTaskConditionsOperator: "OR",
        additionalTaskConditionsOperator: "OR"
      }
    ],
    [
      "0000000000064, export", // "0000000000064", // TASK_CODES.DANGEROUS_GOODS_DECLARATION_RECEIVED
      {
        title: "export.pending.tasks.title.for.submit.dangerous.goods",
        statusCode: "2", //OPEN
        link: "export.pending.tasks.link.for.submit.dangerous.goods",
        permission: "dg-document-submission"
      }
    ]
    // View Draft Bol - remvoing as per AOSM-4801
    // [
    //   "0000000000081, export", // TASK_CODES.ISSUE_VERIFY_COPY_OF_TRANSPORT_DOCUMENT
    //   {
    //     title: "export.pending.tasks.title.for.view.draft.bol",
    //     statusCode: "4", //CLOSED
    //     link: "export.pending.tasks.link.for.view.draft.bol",
    //     permission: "view-draft-tpdoc"
    //   }
    // ]
    // [ NOT MVP - just added to test the method
    //   "0000000000001, export", // TASK_CODES.REVIEW_NOTIFICATION
    //   {
    //     title: "export.pending.tasks.title.for.missing.invoice.details",
    //     statusCode: "2", //OPEN
    //     link: "export.pending.tasks.title.for.missing.invoice.details",
    //     additionalTaskConditions: [
    //       { taskCode: "0000000000001", statusCode: "1" },
    //       { taskCode: "0000000000001", statusCode: "2" },
    //       { taskCode: "0000000000001", statusCode: "3" }
    //     ],
    //     mainAdditionalTaskConditionsOperator: "OR",
    //     additionalTaskConditionsOperator: "OR" //use it between additionalTaskConditions i.e. ATC1 OR ATC2 OR ATC3
    //   }
    // ]
  ]),

  OUTSTANDING_TASKS_MAPPING_COLLECTION: new Map([
    [
      "bookingIsBeingConfirmed", // Carrier Export
      [
        {
          taskCode: "0000000000011", // TASK_CODES.CONFIRM_SHIPMENT
          statusCode: "3" // TASK_STATUSES.IN_PROGRESS
        }
      ]
    ],
    [
      "draftBoLisBeingPrepared", // Carrier Export
      [
        {
          taskCode: "0000000000083", // TASK_CODES.ISSUE_ORIGINAL_TRANSPORT_DOCUMENT
          statusCode: "1" // TASK_STATUSES.PENDING
        }
      ]
    ],
    [
      "finalBoLissuePendingVesselDeparture", // Carrier Export
      [
        {
          taskCode: "0000000000083", // TASK_CODES.ISSUE_ORIGINAL_TRANSPORT_DOCUMENT
          statusCode: "2" // TASK_STATUSES.OPEN
        }
      ]
    ],
    [
      "dangerousGoodsApprovalPending", // Carrier Export
      [
        {
          taskCode: "0000000000064", // TASK_CODES.DANGEROUS_GOODS_DECLARATION_RECEIVED
          statusCode: "3" // TASK_STATUSES.IN_PROGRESS
        }
      ]
    ],
    [
      "processingDeliveryOrderRequest", // Carrier Import
      [
        {
          taskCode: "0000000000074", // TASK_CODES.ARRANGE_CARGO_RELEASE
          statusCode: "3" // TASK_STATUSES.IN_PROGRESS
        }
      ]
    ],
    [
      "submitShippingInstructions", // Customer Export
      [
        {
          taskCode: "0000000000058", // TASK_CODES.RECEIVE_TRANSPORT_DOCUMENT_INSTRUCTIONS
          statusCode: "2" // TASK_STATUSES.OPEN
        },
        {
          taskCode: "0000000000011", // TASK_CODES.CONFIRM_SHIPMENT
          statusCode: "4" // TASK_STATUSES.CLOSED
        }
      ]
    ],
    [
      "submitVGM", // Customer Export
      [
        {
          taskCode: "0000000000129", // TASK_CODES.RESOLVE_MISSING_VGM_DATA
          statusCode: "1" // TASK_STATUSES.PENDING
        },
        {
          taskCode: "0000000000129", // TASK_CODES.RESOLVE_MISSING_VGM_DATA
          statusCode: "2" // TASK_STATUSES.OPEN
        },
        {
          taskCode: "0000000000129", // TASK_CODES.RESOLVE_MISSING_VGM_DATA
          statusCode: "3" // TASK_STATUSES.IN_PROGRESS
        }
      ]
    ],
    [
      "viewDraftBoL", // Customer Export
      [
        {
          taskCode: "0000000000081", // TASK_CODES.ISSUE_VERIFY_COPY_OF_TRANSPORT_DOCUMENT
          statusCode: "4" // TASK_STATUSES.CLOSED
        },
        {
          taskCode: "0000000000095", // TASK_CODES.ISSUE_AMENDED_VERIFY_COPY_OF_TRANSPORT_DOCUMENT
          statusCode: "4" // TASK_STATUSES.CLOSED
        }
      ]
    ],
    [
      "printFinalBoL", // Customer Export
      [
        {
          taskCode: "0000000000083", // TASK_CODES.ISSUE_ORIGINAL_TRANSPORT_DOCUMENT
          statusCode: "4" // TASK_STATUSES.CLOSED
        },
        {
          taskCode: "0000000000083", // TASK_CODES.ISSUE_ORIGINAL_TRANSPORT_DOCUMENT
          statusCode: "4" // TASK_STATUSES.CLOSED
        }
      ]
    ],
    // TODO: Uncomment and replace Print Final BL filter with Print Original BL and Print Waybill filters
    // change task code if necessary
    // [
    //   "printOriginalBoL", // Customer Export
    //   {
    //     taskCode: "0000000000083", // TASK_CODES.ISSUE_ORIGINAL_TRANSPORT_DOCUMENT
    //     statusCode: "4" // TASK_STATUSES.CLOSED
    //   }
    // ],
    // [
    //   "printWaybill", // Customer Export
    //   {
    //     taskCode: "0000000000083", // TASK_CODES.ISSUE_ORIGINAL_TRANSPORT_DOCUMENT
    //     statusCode: "4" // TASK_STATUSES.CLOSED
    //   }
    // ],
    [
      "submitDangerousGoodsDeclaration", // Customer Export
      [
        {
          taskCode: "0000000000064", // TASK_CODES.DANGEROUS_GOODS_DECLARATION_RECEIVED
          statusCode: "2" // TASK_STATUSES.OPEN
        }
      ]
    ],
    [
      "requestDeliveryOrder", // Customer Import
      [
        {
          taskCode: "0000000000074", //TASK_CODES.ARRANGE_CARGO_RELEASE
          statusCode: "2" // TASK_STATUSES.OPEN
        }
      ]
    ],
    [
      "surrenderBoL", // Customer Import
      [
        {
          taskCode: "0000000000069", // TASK_CODES.MARK_ORIGINAL_TRANSPORT_DOCUMENT_AS_RECEIVED,
          statusCode: "2" // TASK_STATUSES.OPEN
        }
      ]
    ],
    [
      "missingInvoiceDetails", // Customer Import
      []
    ]
  ]),

  OUTSTANDING_TASKS_SINGLE_MAPPING_COLLECTION: new Map([
    [
      "submitShippingInstructions", // Customer Export
      {
        taskCode: "0000000000058", // TASK_CODES.RECEIVE_TRANSPORT_DOCUMENT_INSTRUCTIONS
        statusCode: "2" // TASK_STATUSES.OPEN
      }
    ],
    [
      "submitVGM", // Customer Export
      {
        taskCode: "0000000000129", // TASK_CODES.RESOLVE_MISSING_VGM_DATA
        statusCode: "2" // TASK_STATUSES.OPEN
      }
    ],
    [
      "viewDraftBoL", // Customer Export
      {
        taskCode: "0000000000081", // TASK_CODES.ISSUE_VERIFY_COPY_OF_TRANSPORT_DOCUMENT
        statusCode: "4" // TASK_STATUSES.CLOSED
      }
    ],
    [
      "printFinalBoL", // Customer Export
      {
        taskCode: "0000000000083", // TASK_CODES.ISSUE_ORIGINAL_TRANSPORT_DOCUMENT
        statusCode: "4" // TASK_STATUSES.CLOSED
      }
    ],
    // TODO: Uncomment and replace Print Final BL filter with Print Original BL and Print Waybill filters
    // change task code if necessary
    // [
    //   "printOriginalBoL", // Customer Export
    //   {
    //     taskCode: "0000000000083", // TASK_CODES.ISSUE_ORIGINAL_TRANSPORT_DOCUMENT
    //     statusCode: "4" // TASK_STATUSES.CLOSED
    //   }
    // ],
    // [
    //   "printWaybill", // Customer Export
    //   {
    //     taskCode: "0000000000083", // TASK_CODES.ISSUE_ORIGINAL_TRANSPORT_DOCUMENT
    //     statusCode: "4" // TASK_STATUSES.CLOSED
    //   }
    // ],
    [
      "submitDangerousGoodsDeclaration", // Customer Export
      {
        taskCode: "0000000000064", // TASK_CODES.DANGEROUS_GOODS_DECLARATION_RECEIVED
        statusCode: "2" // TASK_STATUSES.OPEN
      }
    ],
    [
      "requestDeliveryOrder", // Customer Import
      {
        taskCode: "0000000000074", //TASK_CODES.ARRANGE_CARGO_RELEASE
        statusCode: "2" // TASK_STATUSES.OPEN
      }
    ],
    [
      "surrenderBoL", // Customer Import
      {
        taskCode: "0000000000069", // TASK_CODES.MARK_ORIGINAL_TRANSPORT_DOCUMENT_AS_RECEIVED,
        statusCode: "2" // TASK_STATUSES.OPEN
      }
    ],
    [
      "missingInvoiceDetails", // Customer Import
      {}
    ]
  ]),

  CONSUMER_KEYS: {
    bolSummary: "K7kIYuvh4ehJ5TEJk60wmLRdNiaGYPJA",
    shipmentDetailsRouter: "OACQ8Wn33tXtSBSsANvfZJYzi0ivTREl",
    orderBlPaper: "peymJ0JjDm5XAOlfVPArppwEOzHC8vra",
    vessels: {
      test: "3C5OkYZKG1upYCOQgEOGUcsSDrxUleGE",
      preprod: "nEyirAzf1nOtsLTvY8LvEZHfkyQvYAG2",
      prod: "nk0Sa1zudw7xarHz0dxCj7kySjuE99en"
    },
    HSM: {
      localhost: "boX3Qd2Qi6JhKUVMsbjy6x2U46Vlw2Kf",
      test: "boX3Qd2Qi6JhKUVMsbjy6x2U46Vlw2Kf",
      preprod: "Ax2eTJ3eGDt7rG0qDy9K84ACZ9NJz0KU",
      prod: "NghzmQKN31Oo7NAyE3TyeV3fcOQae9kN"
    },
    IATA: {
      localhost: "6mVIEo1tNn0fDmBXfPJgZ1p5FP5h50RB",
      test: "6mVIEo1tNn0fDmBXfPJgZ1p5FP5h50RB",
      preprod: "DrGrR7HcX13KEzGcVzXdGernU2Q3BXUp",
      prod: "mHYQkB4Ft4NIlgxgQyvwXlwIyGNpaI9G"
    },
    AIR: {
      localhost: "jR2GHJTHyyXsZnr4GUDr5sRPwKMn8Oy4",
      test: "jR2GHJTHyyXsZnr4GUDr5sRPwKMn8Oy4",
      preprod: "WFy2TBsJRiQG8QSXhnucxg3mB5G2WAvO",
      prod: "a9l7Pgq8P3JAiSJumn3WqGrxAoEoN9pL"
    },
    LCL: {
      localhost: "6mVIEo1tNn0fDmBXfPJgZ1p5FP5h50RB",
      test: "6mVIEo1tNn0fDmBXfPJgZ1p5FP5h50RB",
      preprod: "pTjXBYoLacdZ05y4UccF246EIPXcc4GS",
      prod: "1OzwSA2i7q1O6E9aGyLETNrd7yGahLbD"
    }
  },

  apiPaths: {
    billsOfLadingSummaryApi: `${maerskApiDomain()}/bills-of-lading-summary`,
    locationsApi: `${maerskApiDomain()}/synergy/reference-data/geography/locations`,
    vesselsApi: `${maerskApiDomain()}/synergy/schedules/active-vessels`,
    favouritesApi: `${maerskApiDomain()}/synergy/favourites/user-favourites`,
    cmdSearchPublicDataApi: `${maerskApiDomain()}/customer-identity/customer/manage/public-data`,
    customersApi: `${maerskApiDomain()}/customer-identity/customer/manage`,
    shipmentDetailsApi: `${maerskApiDomain()}/shipment-details`,
    orderBlPaperApi: `${maerskApiDomain()}/hsm-case-management/orderBLPaper`,
    airLclApi: `${maerskApiDomain()}/v1/airlcl/customer`
  },

  USER_ROLES: new Map([
    [1, "Booked By"],
    [2, "Contractual Customer"],
    [3, "Shipper"],
    [4, "Consignee"],
    [5, "First Notify Party"],
    [6, "Additional Notify Party"],
    [7, "Allocation Owner"],
    [11, "Outward Customs Broker"],
    [12, "Inward Customs Broker"],
    [13, "Contractual Carrier's Inward Agent"],
    [14, "Invoice Party"],
    [15, "Outward Forwarder"],
    [16, "Inward Forwarder"],
    [22, "Transport Document Receiver"],
    [25, "Contractual Carrier's Outward Agent"],
    [26, "Credit Party"],
    [27, "Product Owner"],
    [28, "Outward Document Owner"],
    [29, "Inward Document Owner"],
    [31, "Release to Party"],
    [32, "Lawful (BL) Holder"],
    [33, "Demurrage Invoice Party"],
    [34, "Detention Invoice Party"],
    [35, "Supplier"],
    [36, "House Shipper"],
    [37, "House Consignee"],
    [38, "Switched Shipper"],
    [39, "Switched Consignee"],
    [40, "Doc Shipper"],
    [41, "Doc Consignee"],
    [44, "Price Owner"],
    [45, "Named Account Customer"],
    [46, "Export Deal Owner"],
    [47, "Import Deal Owner"],
    [48, "Import Demurrage Payer"],
    [49, "Import Detention Payer"]
  ]),
  OVERVIEW_HEADINGS: {
    overview: "shipmentOverview.title",
    export: "shipmentOverview.export",
    import: "shipmentOverview.import"
  },
  pensieveEnv: `${PENSIEVE_CONFIG[ENV_LABEL]?.env}`,
  pensieveApiKey: `${PENSIEVE_CONFIG[ENV_LABEL]?.apiKey}`,
  pensieveAppName: `${PENSIEVE_CONFIG[ENV_LABEL]?.applicationName}`
};
